// @flow

import styles from './SkewBannerTemplate.less';
import bannerStyles from '../HomePageBanner.less';

import React from 'react';
import classnames from 'classnames';

import { Button, Text, PageBlock } from 'seek-style-guide/react';

type Props = {
  linkProps: Object,
  WrapperComponent: Function,
  bannerCopy?: string,
  headlineCopy?: string,
  subheadingCopy?: string,
  buttonCopy: string,
  imageVariant: string,
  bgColor?: string,
  buttonProps?: Object
};

export default ({
  bgColor,
  linkProps,
  WrapperComponent,
  bannerCopy,
  buttonCopy,
  imageVariant,
  subheadingCopy,
  buttonProps,
  headlineCopy
}: Props) => {
  const bannerClasses = classnames({
    [styles.bannerSection]: true,
    [styles.tealBackground]: bgColor === 'teal'
  });

  const imageClasses = classnames({
    [styles.image]: true,
    [styles.profileBanner]: imageVariant === 'profileBanner'
  });

  return (
    <PageBlock className={bannerStyles.root}>
      <WrapperComponent
        aria-label={buttonCopy}
        className={bannerClasses}
        {...linkProps}
      >
        <div className={styles.content}>
          <div className={styles.text}>
            {headlineCopy && <Text headline>{headlineCopy}</Text>}
            {bannerCopy && <Text heading>{bannerCopy}</Text>}
            {subheadingCopy && <Text subheading>{subheadingCopy}</Text>}
          </div>
          <Button className={styles.button} color="blue" {...buttonProps}>
            {buttonCopy}
          </Button>
        </div>
        <div className={imageClasses} />
      </WrapperComponent>
    </PageBlock>
  );
};
